import { Outlet } from "react-router-dom";
import Navigation from "../navBar";

const NoHeaderLayout = () => {
  return (
    <>
      <div className="no-header-nav">
        <Navigation logIn={false} />
      </div>
      <Outlet />
    </>
  )
};

export default NoHeaderLayout;